import type { ElementType, ReactNode, ComponentPropsWithoutRef } from 'react';

import { cls } from '@/utils/cls';

type Props<T extends ElementType = 'div'> = {
  as?: T;
  children?: ReactNode;
  className?: string;
  title?: string;
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'children' | 'className'>;

export function Card<T extends ElementType = 'div'>({ as, className, children, title, ...rest }: Props<T>) {
  const Component = as ?? 'div';
  const containerClass = cls('bg-white rounded-lg border border-gray-200 p-6', className);

  return (
    <Component {...rest} className={containerClass}>
      {title ? <h3 className="text-sm font-semibold text-gray-900">{title}</h3> : null}
      {children}
    </Component>
  );
}
